import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getTargetValueReportsEndpoint } from '../../../common/endpoints';

export const getTargetValueReports = createApi(getTargetValueReportsEndpoint, 'GET');

const TargetValueReports = createSlice({
  name: 'TargetValueReports',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTargetValueReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTargetValueReports.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getTargetValueReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default TargetValueReports.reducer;